import { render, staticRenderFns } from "./SoalForm.vue?vue&type=template&id=3db8deb7&scoped=true"
import script from "./SoalForm.vue?vue&type=script&lang=js"
export * from "./SoalForm.vue?vue&type=script&lang=js"
import style0 from "./SoalForm.vue?vue&type=style&index=0&id=3db8deb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db8deb7",
  null
  
)

export default component.exports